import { z } from "zod";

// ─── Public gathering listing ────────────────────────────────────────────────

export const publicGatheringListQuerySchema = z.object({
  city: z.string().trim().min(1).max(120).optional(),
});
export type PublicGatheringListQueryInput = z.infer<
  typeof publicGatheringListQuerySchema
>;

// ─── Public RSVP (email + name, no account) ─────────────────────────────────

export const publicRsvpSchema = z.object({
  email: z.string().trim().email("Enter a valid email address").max(254),
  name: z.string().trim().min(1, "Name is required").max(120),
  // Token minted by the hCaptcha widget on the public RSVP form. The API
  // verifies it server-side; absence is rejected when the API is configured
  // with a secret. Optional in the schema so dev environments without a
  // secret can still submit, where the verifier short-circuits.
  captchaToken: z.string().min(1).max(4096).optional(),
});
export type PublicRsvpInput = z.infer<typeof publicRsvpSchema>;

// ─── Waitlist signup ─────────────────────────────────────────────────────────

export const waitlistSourceEnum = z.enum(["marketing", "discover-city"]);
export type WaitlistSource = z.infer<typeof waitlistSourceEnum>;

export const waitlistSignupSchema = z.object({
  email: z.string().trim().email("Enter a valid email address").max(254),
  source: waitlistSourceEnum,
  city: z.string().trim().min(1).max(120).optional(),
});
export type WaitlistSignupInput = z.infer<typeof waitlistSignupSchema>;
